function SegLabel() {
  return <div></div>;
}

export default SegLabel;
